import { api, handleResponse, handleError } from "./apiServices";

export const getUserAllNotifications = (token, params) =>
  api(token)
    .post(`/api/venue/notifications/all`, params)
    .then(handleResponse)
    .catch(handleError);

export const markUserNoticationsRead = token =>
  api(token)
    .post(`/api/venue/notifications/mark/read`)
    .then(handleResponse)
    .catch(handleError);

export const markEscalatNotificationReadById = (token, id) =>
  api(token)
    .post(`/api/venue/notifications/mark/read/${id}`)
    .then(handleResponse)
    .catch(handleError);

// export const deleteUserNotificationById = (token, id) =>
//   api(token)
//     .delete(`/user/notification/delete/${id}`)
//     .then(handleResponse)
//     .catch(handleError);

export const unreadNotificationsCount = token =>
  api(token)
    .get(`/api/venue/notifications/unread/count`)
    .then(handleResponse)
    .catch(handleError);
